import React, { Suspense, lazy } from 'react'
import { isMobile, MobileView, BrowserView } from 'react-device-detect'
import { Dialog, Container, Grid, IconButton } from '@material-ui/core'
import CircledPopUpFrame from '../Core/CircledPopUpFrame';
import { BackButtonTitle } from '../Core/BackButtonTitle';
import { DeleteIcon } from '@material-ui/icons/Delete';
import { Close, Delete } from '@material-ui/icons';
const SideMenu = lazy(() => import('../SideMenu/SideMenu'));

interface SkywatchDialogProps {
    open: Boolean,
    closeDialog: Function,
    children: any,
    closeTitle: String,
    circleHeader: any,
    maxWidth: String,
}

export const SkywatchDialog = ({open, closeDialog, children, circleHeader, closeTitle, maxWidth = 'md', narrowContainer=false, includeCancelButton=true, ...props }: SkywatchDialogProps) => {
    return (<Dialog
                BackdropProps={{style: {backgroundColor: 'white', opacity: isMobile ? 1 : 0.64}}}
                fullWidth
                fullScreen={isMobile}
                open={open}
                onClose={closeDialog}
                PaperProps={{style: {backgroundColor: 'transparent', boxShadow: 'none'}}}
                maxWidth={maxWidth}>
                    <MobileView>
                        <Suspense fallback={<div />}>
                            <SideMenu />
                        </Suspense>
                        <Container>
                            <BackButtonTitle onBackPressed={closeDialog} title={closeTitle} />
                            <br />
                            {children}
                        </Container>
                    </MobileView>
                    <BrowserView>
                        <CircledPopUpFrame showClose closeDialog={closeDialog} circleHeader={circleHeader} narrowContainer={narrowContainer} includeCancelButton={includeCancelButton}>
                            {children}
                        </CircledPopUpFrame>
                    </BrowserView>
            </Dialog>)
}